// extracted by mini-css-extract-plugin
export default {"main":"startpage_main__QRPZo"};